'use strict';

import * as dom from './lib/dom.js'; 

export default function() {
    window.addEventListener('load', function() {
        const footerFixed = document.querySelector('.o-ads-fixed-footer');
        // dom.addClass(footerFixed, 'active');

        const footerFixedCloseBtn = document.querySelector('.js-close-fixed-footer');
        if (footerFixedCloseBtn) {
            footerFixedCloseBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                dom.removeClass(footerFixed, 'active');
            });
        }
        
    })
}